let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("lhNuR"), load("7cPsw"), load("hIdf1")]).then(() => parcelRequire('fgD68'));